import { TransformedDataPoint } from './prepareChartData';

interface RawLeadsChartsDbData {
  date: string;
  statuses: {
    status: string;
    count: number;
  }[];
}

export interface LineConfig {
  key: string; // dataKey для Recharts
  name: string; // відображуване ім'я в легенді
  color: string; // колір лінії
  statuses?: { status: string; count: number }[];
}

const getStatusColor = (status: string): string => {
  // Проста логіка для призначення кольорів на основі статусу
  switch (status.toLowerCase()) {
    case 'new':
      return '#4caf50'; // зелений
    case 'converted':
      return '#2196f3'; // синій
    case 'declined':
      return '#f44336'; // червоний
    default:
      return '#9e9e9e'; // сірий для невідомих статусів
  }
};

export const prepareLeadsChartData = (
  rawData: RawLeadsChartsDbData[],
): {
  data: TransformedDataPoint[];
  lines: LineConfig[];
} => {
  // 1. Збираємо унікальні статуси з усіх дат
  console.log('Preparing leads chart data with raw data:', rawData);
  const statusMap = new Map<
    string,
    { color: string; statuses: { status: string; count: number }[] }
  >();
  for (const day of rawData) {
    for (const statusInfo of day.statuses) {
      if (!statusMap.has(statusInfo.status)) {
        // Assign a color based on the status (you can customize this logic)
        const color = getStatusColor(statusInfo.status);
        statusMap.set(statusInfo.status, {
          color,
          statuses: [{ status: statusInfo.status, count: statusInfo.count }],
        });
      }
    }
  }

  // 2. Створюємо конфігурацію ліній
  const lines: LineConfig[] = Array.from(statusMap.entries()).map(([status, info]) => ({
    key: `status_${status}`,
    name: status,
    color: info.color,
    statuses: info.statuses,
  }));

  // 3. Перетворюємо дані у формат [{ name: 'дата', status_1: count, status_2: count, ... }]
  const data: TransformedDataPoint[] = rawData.map((day) => {
    const point: TransformedDataPoint = { name: day.date.split('-').reverse().join('.') };
    // initialize all known statuses with 0 to avoid broken lines when a status is missing on a date
    for (const status of Array.from(statusMap.keys())) {
      point[`status_${status}`] = 0;
    }
    for (const statusInfo of day.statuses) {
      point[`status_${statusInfo.status}`] = statusInfo.count;
    }
    return point;
  });

  return { data, lines };
};
